import * as RadixDialog from '@radix-ui/react-dialog'
import { keyframes, styled } from '../../../config'

const overlayShow = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
})

export const Overlay = styled(RadixDialog.Overlay, {
  backgroundColor: 'rgba(0,0,0,.5)',
  position: 'fixed',
  inset: 0,
  animation: `${overlayShow} 600ms cubic-bezier(0.16, 1, 0.3, 1)`,
  zIndex: 100
})
